/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Provider } from '@angular/core';
import { UserRegistrationService } from './user-registration.service';
import {UserRegistrationFacade} from "../../root/facade";

export const facadeProviders: Provider[] = [
  UserRegistrationService,
  {
    provide: UserRegistrationFacade,
    useExisting: UserRegistrationService,
  },
];
